"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _core = require("@material-ui/core");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _styles = require("@material-ui/styles");

var _FormItemsDependency = _interopRequireDefault(require("./FormItemsDependency"));

var _FormItemAttributes = _interopRequireDefault(require("./FormItemAttributes"));

var _FormItemValidations = _interopRequireDefault(require("./FormItemValidations"));

var _FormItemSources = _interopRequireDefault(require("./FormItemSources"));

var _DependencyBuilder = _interopRequireDefault(require("./DependencyBuilder"));

var _DefaultValuesBuilder = _interopRequireDefault(require("./DefaultValuesBuilder"));

var _utils = _interopRequireDefault(require("../utils"));

var _StylesAtributes = _interopRequireDefault(require("./Atributes/StylesAtributes"));

var _GridLayoutAtributes = _interopRequireDefault(require("./Atributes/GridLayoutAtributes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    titleHeader: {
      textAlign: "center"
    }
  };
});

var FormItemPropertiesStore = function FormItemPropertiesStore() {
  var _this = this;

  _classCallCheck(this, FormItemPropertiesStore);

  _defineProperty(this, "isModalOpen", false);

  _defineProperty(this, "isDependencyModalOpen", false);

  _defineProperty(this, "isDefaultValueModalOpen", false);

  _defineProperty(this, "tabIndex", 0);

  _defineProperty(this, "openModal", function () {
    _this.isModalOpen = true;
  });

  _defineProperty(this, "closeModal", function () {
    _this.isModalOpen = false;
  });

  _defineProperty(this, "openDependencyModal", function () {
    _this.isDependencyModalOpen = true;
  });

  _defineProperty(this, "closeDependencyModal", function () {
    _this.isDependencyModalOpen = false;
  });

  _defineProperty(this, "openDefaultValueModal", function () {
    _this.isDefaultValueModalOpen = true;
  });

  _defineProperty(this, "closeDefaultValueModal", function () {
    _this.isDefaultValueModalOpen = false;
  });
};

var DependencyBuilderStore = function DependencyBuilderStore() {
  var _this2 = this;

  _classCallCheck(this, DependencyBuilderStore);

  _defineProperty(this, "dependencies", []);

  _defineProperty(this, "addDependency", function (dependency) {
    _this2.dependencies.push(dependency);
  });

  _defineProperty(this, "findDependency", function (dependencyId) {
    var dependency = _this2.dependencies.find(function (x) {
      return x.id === dependencyId;
    });

    return dependency;
  });

  _defineProperty(this, "removeDependency", function (dependencyId) {
    var index = _this2.dependencies.indexOf(_this2.findDependency(dependencyId));

    _this2.dependencies.splice(index, 1);
  });

  _defineProperty(this, "editDependencyName", function (dependencyId, name) {
    var dependencies = _this2.dependencies.map(function (dependency) {
      var d = dependency;

      if (d.id === dependencyId) {
        d.name = name;
      }

      return d;
    });

    _this2.dependencies = dependencies;
  });

  _defineProperty(this, "editDependencyField", function (dependencyId, field) {
    var dependencies = _this2.dependencies.map(function (dependency) {
      var d = dependency;

      if (d.id === dependencyId) {
        d.field = field;
      }

      return d;
    });

    _this2.dependencies = dependencies;
  });

  _defineProperty(this, "editDependencyTrigger", function (dependencyId, isTrigger) {
    var dependencies = _this2.dependencies.map(function (dependency) {
      var d = dependency;

      if (d.id === dependencyId) {
        d.isTrigger = isTrigger;
      }

      return d;
    });

    _this2.dependencies = dependencies;
  });

  this.dependencies = [];
};

var DefaultValuesBuilderStore = function DefaultValuesBuilderStore() {
  var _this3 = this;

  _classCallCheck(this, DefaultValuesBuilderStore);

  _defineProperty(this, "defaultValues", []);

  _defineProperty(this, "addDefaultValue", function (defaultValue) {
    _this3.defaultValues.push(defaultValue);
  });

  _defineProperty(this, "findDefaultValue", function (defaultValueId) {
    var defaultValue = _this3.defaultValues.find(function (x) {
      return x.id === defaultValueId;
    });

    return defaultValue;
  });

  _defineProperty(this, "removeDefaultValue", function (defaultValueId) {
    var index = _this3.defaultValues.indexOf(_this3.findDefaultValue(defaultValueId));

    _this3.defaultValues.splice(index, 1);
  });

  _defineProperty(this, "editDefaultValueKey", function (defaultValueId, key) {
    var defaultValues = _this3.defaultValues.map(function (defaultValue) {
      var d = defaultValue;

      if (d.id === defaultValueId) {
        d.key = key;
      }

      return d;
    });

    _this3.defaultValues = defaultValues;
  });

  _defineProperty(this, "editDefaultValue", function (defaultValueId, value) {
    var defaultValues = _this3.defaultValues.map(function (defaultValue) {
      var d = defaultValue;

      if (d.id === defaultValueId) {
        d.value = value;
      }

      return d;
    });

    _this3.defaultValues = defaultValues;
  });

  _defineProperty(this, "editDependencyTrigger", function (defaultValueId, isTrigger) {
    var defaultValues = _this3.defaultValues.map(function (defaultValue) {
      var d = defaultValue;

      if (d.id === defaultValueId) {
        d.isTrigger = isTrigger;
      }

      return d;
    });

    _this3.defaultValues = defaultValues;
  });

  this.defaultValues = [];
};

var FormItemProperties = /*#__PURE__*/function (_Component) {
  _inherits(FormItemProperties, _Component);

  var _super = _createSuper(FormItemProperties);

  function FormItemProperties() {
    var _this4;

    _classCallCheck(this, FormItemProperties);

    _this4 = _super.call(this);

    _defineProperty(_assertThisInitialized(_this4), "onModalOpen", function (properties) {
      if (_this4.props.store.serverList.length === 0 && properties.source.type === 2) {
        _this4.props.store.fetchServerList();
      }

      if (Object.keys(properties.source.parameters) === 0) {
        _this4.props.store.setParameters(properties);
      }
    });

    _defineProperty(_assertThisInitialized(_this4), "onModalClose", function (props) {
      if (props.type === "datagrid") {
        var metadata = props.source.parameters.metadata;
        var metadataFields = metadata ? metadata.types[Object.keys(metadata.types ? metadata.types : {}).find(function (type) {
          return _this4.metadataSimilarities(metadata.output, type) < 1 && _this4.metadataSimilarities(metadata.output, type) >= 0.75;
        })].elements.map(function (m) {
          return {
            label: Object.keys(m)[0],
            name: Object.keys(m)[0],
            hideOnGrid: false,
            isSearchable: false,
            type: {
              multiple: false,
              name: m[Object.keys(m)[0]].includes("int") ? "number" : "text"
            }
          };
        }) : [];

        _this4.props.store.handleItemAttribute(props, "definition", metadataFields);
      } // this.props.store.clearMetadata();

    });

    _defineProperty(_assertThisInitialized(_this4), "onDependencyModalOpen", function (properties) {
      _this4.dependencyBuilderStore.dependencies = properties.dependencies;
    });

    _defineProperty(_assertThisInitialized(_this4), "onDefaultValueModalOpen", function (properties) {
      _this4.defaultValueBuilderStore.defaultValues = properties.source.defaultValues;
    });

    _defineProperty(_assertThisInitialized(_this4), "onDependencyModalClose", function () {// console.log("Modal closed!");
      // this.props.store.handleItemPropertyChange(properties, 'dependencies', this.dependencyBuilderStore.dependencies);
    });

    _defineProperty(_assertThisInitialized(_this4), "onDefaultValueModalClose", function () {// this.props.store.handleSourceConfig(properties, 'defaultValues', this.defaultValueBuilderStore.defaultValues);
    });

    _defineProperty(_assertThisInitialized(_this4), "setField", function (properties, key, value) {
      _this4.props.store.handleSourceParameterConfig(properties, key, value);
    });

    _defineProperty(_assertThisInitialized(_this4), "handleSourceConfig", function (properties, key, value) {
      _this4.props.store.handleSourceConfig(properties, key, value);
    });

    _defineProperty(_assertThisInitialized(_this4), "fetchServices", function (properties, serverName) {
      _this4.props.store.fetchServerServices(properties, serverName);
    });

    _defineProperty(_assertThisInitialized(_this4), "fetchServiceOperations", function (properties, serviceName) {
      _this4.props.store.fetchServicesOperations(properties, serviceName);
    });

    _defineProperty(_assertThisInitialized(_this4), "fetchOperationMetadata", function (properties, operation) {
      _this4.props.store.fetchOperationMetadata(properties, operation);
    });

    _defineProperty(_assertThisInitialized(_this4), "fetchEntities", function (properties, value) {
      _this4.props.formStore.fetchEntities(value);

      _this4.setField(properties, "assembly", value); // this.props.store.handleSourceConfig(properties, 'assembly', value);

    });

    _defineProperty(_assertThisInitialized(_this4), "fetchFields", function (properties, value) {
      _this4.props.formStore.fetchFields(value);

      _this4.setField(properties, "entity", value); // this.props.store.handleSourceConfig(properties, 'entity', value);

    });

    _defineProperty(_assertThisInitialized(_this4), "openModal", function () {
      _this4.formItemPropertiesStore.openModal();
    });

    _defineProperty(_assertThisInitialized(_this4), "openDependencyModal", function () {
      _this4.formItemPropertiesStore.openDependencyModal();
    });

    _defineProperty(_assertThisInitialized(_this4), "openDefaultValueModal", function () {
      _this4.formItemPropertiesStore.openDefaultValueModal();
    });

    _defineProperty(_assertThisInitialized(_this4), "closeModal", function () {
      _this4.formItemPropertiesStore.closeModal();
    });

    _defineProperty(_assertThisInitialized(_this4), "closeDependencyModal", function () {
      _this4.formItemPropertiesStore.closeDependencyModal();
    });

    _defineProperty(_assertThisInitialized(_this4), "closeDefaultValueModal", function () {
      _this4.formItemPropertiesStore.closeDefaultValueModal();
    });

    _defineProperty(_assertThisInitialized(_this4), "addDependency", function () {
      var newDependency = {
        id: _utils.default.getNewId(),
        field: "",
        name: ""
      };

      _this4.dependencyBuilderStore.addDependency(newDependency);
    });

    _defineProperty(_assertThisInitialized(_this4), "addDefaultValue", function () {
      var newDefaultValue = {
        id: _utils.default.getNewId(),
        key: "",
        value: ""
      };

      _this4.defaultValueBuilderStore.addDefaultValue(newDefaultValue);
    });

    _defineProperty(_assertThisInitialized(_this4), "metadataSimilarities", function (s1, s2) {
      var longer = s1;
      var shorter = s2;

      if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
      }

      var longerLength = longer.length;

      if (longerLength === 0) {
        return 1.0;
      }

      return (longerLength - _this4.editDistance(longer, shorter)) / parseFloat(longerLength);
    });

    _defineProperty(_assertThisInitialized(_this4), "editDistance", function (s1, s2) {
      var lowerCasedS1 = s1.toLowerCase();
      var lowerCasedS2 = s2.toLowerCase();
      var costs = [];

      for (var i = 0; i <= lowerCasedS1.length; i++) {
        var lastValue = i;

        for (var j = 0; j <= lowerCasedS2.length; j++) {
          if (i === 0) {
            costs[j] = j;
          } else {
            if (j > 0) {
              var newValue = costs[j - 1];

              if (lowerCasedS1.charAt(i - 1) !== lowerCasedS2.charAt(j - 1)) {
                newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
              }

              costs[j - 1] = lastValue;
              lastValue = newValue;
            }
          }
        }

        if (i > 0) {
          costs[lowerCasedS2.length] = lastValue;
        }
      }

      return costs[lowerCasedS2.length];
    });

    _defineProperty(_assertThisInitialized(_this4), "modalButtonAction", function (properties, store) {
      return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal.Content, null, /*#__PURE__*/_react.default.createElement("form", {
        style: {
          marginBottom: "1.8rem"
        }
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
        columns: "equal",
        padded: true
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
        mobile: 16
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "field"
      }, /*#__PURE__*/_react.default.createElement("label", null, "Lista de servidores: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
        placeholder: "Seleccione el servidor",
        selection: true,
        search: true,
        defaultValue: properties.source.parameters.server,
        options: store.serverList.slice(),
        onChange: function onChange(event, data) {
          _this4.fetchServices(properties, data.value); //console.log(data);

        },
        loading: store.serverList.length === 0
      })))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
        mobile: 16
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "field"
      }, /*#__PURE__*/_react.default.createElement("label", null, "Servicios del servidor: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
        placeholder: "Seleccione el servicio",
        selection: true,
        search: true,
        defaultValue: properties.source.parameters.service.name !== "" ? "".concat(properties.source.parameters.service.name, "&").concat(properties.source.parameters.service.url) : "",
        options: store.serverServices.slice(),
        onChange: function onChange(event, data) {
          _this4.fetchServiceOperations(properties, data.value);
        },
        loading: properties.source.parameters.server !== "" && store.serverServices.length === 0
      })))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
        mobile: 16
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "field"
      }, /*#__PURE__*/_react.default.createElement("label", null, "Operaciones del servicio: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
        placeholder: "Seleccione la operaci\xF3n",
        selection: true,
        search: true,
        defaultValue: properties.source.parameters.operation,
        options: store.serviceOperations.slice(),
        onChange: function onChange(event, data) {
          _this4.fetchOperationMetadata(properties, data.value);
        },
        loading: properties.source.parameters.service.name !== "" && store.serviceOperations.length === 0
      })))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null))));
    });

    _defineProperty(_assertThisInitialized(_this4), "modalSelectAction", function (properties, store, formStore) {
      switch (properties.source.type) {
        case 1:
          {
            var definitionFields = formStore.entityDefinition.map(function (f) {
              return {
                key: f.name,
                value: f.name,
                text: f.name
              };
            }).slice();
            return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal.Content, null, /*#__PURE__*/_react.default.createElement("form", {
              style: {
                marginBottom: "1.8rem"
              }
            }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
              columns: "equal",
              padded: true
            }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
              mobile: 16
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "field"
            }, /*#__PURE__*/_react.default.createElement("label", null, "Paquete: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
              placeholder: "Seleccione el Paquete",
              selection: true,
              search: true,
              defaultValue: properties.source.parameters.assembly,
              options: formStore.assemblies.slice(),
              onChange: function onChange(event, data) {
                _this4.fetchEntities(properties, data.value);
              },
              loading: formStore.assemblies.length === 0
            })))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
              mobile: 16
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "field"
            }, /*#__PURE__*/_react.default.createElement("label", null, "Clase: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
              placeholder: "Seleccione la Clase",
              selection: true,
              search: true,
              defaultValue: properties.source.parameters.entity,
              options: formStore.entityOptions.slice(),
              onChange: function onChange(event, data) {
                _this4.fetchFields(properties, data.value);
              },
              loading: properties.source.parameters.assembly !== "" && formStore.entityOptions.length === 0
            })))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
              mobile: 16
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "field"
            }, /*#__PURE__*/_react.default.createElement("label", null, "Texto: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
              placeholder: "Seleccione el Texto",
              selection: true,
              search: true,
              defaultValue: properties.source.parameters.text,
              options: definitionFields,
              onChange: function onChange(event, data) {
                _this4.setField(properties, "text", data.value);
              },
              loading: properties.source.parameters.entity !== "" && formStore.entityDefinition.length === 0
            })))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
              mobile: 16
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "field"
            }, /*#__PURE__*/_react.default.createElement("label", null, "Valor: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
              placeholder: "Seleccione el Valor",
              selection: true,
              search: true,
              defaultValue: properties.source.parameters.value,
              options: definitionFields,
              onChange: function onChange(event, data) {
                _this4.setField(properties, "value", data.value);
              },
              loading: properties.source.parameters.entity !== "" && formStore.entityDefinition.length === 0
            })))))));
          }

        case 2:
          {
            var metadata = properties.source.parameters.metadata; // const metadataFields = metadata ? metadata.types[metadata.output.substring(7, metadata.output.length)].elements.map((m) => {
            //   console.log(m);
            //   return {
            //     key: Object.keys(m)[0],
            //     text: Object.keys(m)[0],
            //     value: Object.keys(m)[0]
            //   };
            // }) : [];

            var metadataFields = metadata ? metadata.types[Object.keys(metadata.types ? metadata.types : {}).find(function (type) {
              return _this4.metadataSimilarities(metadata.output, type) < 1 && _this4.metadataSimilarities(metadata.output, type) >= 0.75;
            })].elements.map(function (m) {
              return {
                key: Object.keys(m)[0],
                text: Object.keys(m)[0],
                value: Object.keys(m)[0]
              };
            }) : [];
            return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal.Content, null, /*#__PURE__*/_react.default.createElement("form", {
              style: {
                marginBottom: "1.8rem"
              }
            }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
              columns: "equal",
              padded: true
            }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
              mobile: 16
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "field"
            }, /*#__PURE__*/_react.default.createElement("label", null, "Lista de servidores: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
              placeholder: "Seleccione el servidor",
              selection: true,
              search: true,
              defaultValue: properties.source.parameters.server,
              options: store.serverList.slice(),
              onChange: function onChange(event, data) {
                _this4.fetchServices(properties, data.value); //console.log(data);

              },
              loading: store.serverList.length === 0
            })))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
              mobile: 16
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "field"
            }, /*#__PURE__*/_react.default.createElement("label", null, "Servicios del servidor: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
              placeholder: "Seleccione el servicio",
              selection: true,
              search: true,
              defaultValue: properties.source.parameters.service ? "".concat(properties.source.parameters.service.name, "&").concat(properties.source.parameters.service.url) : "",
              options: store.serverServices.slice(),
              onChange: function onChange(event, data) {
                _this4.fetchServiceOperations(properties, data.value);
              },
              loading: properties.source.parameters.server === "" && store.serverServices.length === 0
            })))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
              mobile: 16
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "field"
            }, /*#__PURE__*/_react.default.createElement("label", null, "Operaciones del servicio: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
              placeholder: "Seleccione la operaci\xF3n",
              selection: true,
              search: true,
              defaultValue: properties.source.parameters.operation,
              options: store.serviceOperations.slice(),
              onChange: function onChange(event, data) {
                _this4.fetchOperationMetadata(properties, data.value);
              },
              loading: properties.source.parameters.service && store.serviceOperations.length === 0
            })))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
              mobile: 16
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "field"
            }, /*#__PURE__*/_react.default.createElement("label", null, "Texto: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
              placeholder: "Seleccione el Texto",
              selection: true,
              search: true,
              defaultValue: properties.source.parameters.text,
              options: metadataFields,
              onChange: function onChange(event, data) {
                _this4.setField(properties, "text", data.value);
              },
              loading: !properties.source.parameters.metadata
            })))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
              mobile: 16
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "field"
            }, /*#__PURE__*/_react.default.createElement("label", null, "Valor: "), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
              placeholder: "Seleccione el Valor",
              selection: true,
              search: true,
              defaultValue: properties.source.parameters.value,
              options: metadataFields,
              onChange: function onChange(event, data) {
                _this4.setField(properties, "value", data.value);
              },
              loading: !properties.source.parameters.metadata
            })))))));
          }

        default:
          // console.log("Undefined type");
          return;
      }
    });

    _defineProperty(_assertThisInitialized(_this4), "loadContentModal", function (properties) {
      if (properties.type === "button" || properties.type === "datagrid") {// return this.modalButtonAction(properties, store);
      } else if (properties.type === "select" || properties.type === "autocomplete") {// return this.modalSelectAction(properties, store, formStore);
      }
    });

    _this4.formItemPropertiesStore = new FormItemPropertiesStore();
    _this4.dependencyBuilderStore = new DependencyBuilderStore();
    _this4.defaultValueBuilderStore = new DefaultValuesBuilderStore();
    _this4.activeIndex = 0;
    return _this4;
  }

  _createClass(FormItemProperties, [{
    key: "render",
    value: function render() {
      var _properties$isChild,
          _this5 = this;

      var _this$props = this.props,
          handleItemAttribute = _this$props.handleItemAttribute,
          handleItemValidation = _this$props.handleItemValidation,
          handlePropertyChange = _this$props.handlePropertyChange,
          handleItemSource = _this$props.handleItemSource,
          handleItemDependencies = _this$props.handleItemDependencies,
          handleAddItemForm = _this$props.handleAddItemForm,
          gridSize = _this$props.gridSize,
          store = _this$props.store,
          formStore = _this$props.formStore,
          objectsForm = _this$props.objectsForm,
          itemProperties = _this$props.itemProperties,
          typeForm = _this$props.typeForm,
          advanceCount = _this$props.advanceCount;
      var properties = itemProperties;
      var dependencies = objectsForm.filter(function (item) {
        return item.type === "select" && item.i !== properties.i;
      }).map(function (item) {
        return {
          key: item.i,
          text: item.name,
          value: item.i
        };
      });
      var parentId = properties === null || properties === void 0 ? void 0 : (_properties$isChild = properties.isChild) === null || _properties$isChild === void 0 ? void 0 : _properties$isChild.parentId;

      var isChild = function isChild() {
        return objectsForm.some(function (obj) {
          return obj.i === parentId;
        });
      };

      if (isChild()) {
        return /*#__PURE__*/_react.default.createElement(Header, {
          title: "Para configurar este select debe ir al select padre:\n          Select: ".concat(objectsForm.find(function (obj) {
            return obj.i === parentId;
          }).attributes.label),
          style: {
            whiteSpace: "pre-line"
          }
        });
      }

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("form", {
        style: {
          marginBottom: "1rem"
        }
      }, properties.type !== "label" && properties.type !== "accordion" && /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
        title: "Name del input",
        "aria-label": "type",
        placement: "top"
      }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
        label: "Nombre",
        value: properties.name,
        onChange: function onChange(e) {
          return handlePropertyChange(properties, "name", e.target.value.trim());
        }
      }))), /*#__PURE__*/_react.default.createElement(_core.Accordion, null, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
        expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
        "aria-controls": "panel1a-content",
        id: "panel1a-header"
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        className: "bold"
      }, "General")), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, {
        style: {
          display: "block"
        }
      }, /*#__PURE__*/_react.default.createElement(_FormItemAttributes.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        typeForm: typeForm
      }))), properties.validations && /*#__PURE__*/_react.default.createElement(_core.Accordion, null, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
        expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
        "aria-controls": "panel2a-content",
        id: "panel2a-header"
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        className: "bold"
      }, "Validaciones")), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, null, /*#__PURE__*/_react.default.createElement(_FormItemValidations.default, {
        properties: properties,
        handleItemValidation: handleItemValidation
      }))), properties.type === "input" && /*#__PURE__*/_react.default.createElement(_core.Accordion, null, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
        expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
        "aria-controls": "panel1a-content",
        id: "panel1a-header"
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        className: "bold"
      }, "Dependencia")), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, {
        style: {
          display: "block"
        }
      }, /*#__PURE__*/_react.default.createElement(_FormItemsDependency.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        typeForm: typeForm
      }))), properties.source && /*#__PURE__*/_react.default.createElement(_core.Accordion, null, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
        expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
        "aria-controls": "panel3a-content",
        id: "panel3a-header"
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        className: "bold"
      }, properties.type === "button" ? "Endpoint para guardar el formulario" : "Origen de datos")), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, null, /*#__PURE__*/_react.default.createElement(_FormItemSources.default, {
        properties: properties,
        objectsForm: objectsForm,
        handleItemSource: handleItemSource,
        handleItemDependencies: handleItemDependencies,
        handleAddItemForm: handleAddItemForm,
        gridSize: gridSize
      }))), /*#__PURE__*/_react.default.createElement(_core.Accordion, null, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
        expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
        "aria-controls": "panel1a-content",
        id: "panel1a-header"
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        className: "bold"
      }, "Estilos")), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, {
        style: {
          display: "block"
        }
      }, /*#__PURE__*/_react.default.createElement(_StylesAtributes.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        typeForm: typeForm
      }))), /*#__PURE__*/_react.default.createElement(_core.Accordion, null, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
        expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
        "aria-controls": "panel1a-content",
        id: "panel1a-header"
      }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        className: "bold"
      }, "Propiedades de celda")), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, {
        style: {
          display: "block"
        }
      }, /*#__PURE__*/_react.default.createElement(_GridLayoutAtributes.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        typeForm: typeForm
      }))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal, {
        open: this.formItemPropertiesStore.isModalOpen,
        className: "scrolling",
        onMount: function onMount() {
          _this5.onModalOpen(properties);
        },
        onUnmount: function onUnmount() {
          _this5.onModalClose(properties);
        }
      }, /*#__PURE__*/_react.default.createElement(Header, {
        title: "Configurar acci\xF3n"
      }), this.loadContentModal(properties, store, formStore), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal.Actions, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
        onClick: function onClick() {
          _this5.closeModal();
        },
        content: "Aceptar",
        size: "medium",
        className: "uif2btnStyle uif2Primary"
      }))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal, {
        open: this.formItemPropertiesStore.isDependencyModalOpen,
        className: "scrolling",
        onMount: function onMount() {
          _this5.onDependencyModalOpen(properties);
        },
        onUnmount: function onUnmount() {
          _this5.onDependencyModalClose(properties);
        }
      }, /*#__PURE__*/_react.default.createElement(Header, {
        title: "Configurar dependencias"
      }), /*#__PURE__*/_react.default.createElement(_DependencyBuilder.default, {
        store: this.dependencyBuilderStore,
        schema: dependencies
      }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal.Actions, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
        onClick: function onClick() {
          _this5.addDependency();
        },
        content: "Agregar",
        size: "medium",
        className: "uif2btnStyle"
      }), /*#__PURE__*/_react.default.createElement(_core.Button, {
        onClick: function onClick() {
          _this5.closeDependencyModal();
        },
        content: "Cerrar",
        size: "medium",
        className: "uif2btnStyle uif2Primary"
      }))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal, {
        open: this.formItemPropertiesStore.isDefaultValueModalOpen,
        className: "scrolling",
        onMount: function onMount() {
          _this5.onDefaultValueModalOpen(properties);
        },
        onUnmount: function onUnmount() {
          _this5.onDefaultValueModalClose(properties);
        }
      }, /*#__PURE__*/_react.default.createElement(Header, {
        title: "Configurar valores por defecto"
      }), /*#__PURE__*/_react.default.createElement(_DefaultValuesBuilder.default, {
        store: this.defaultValueBuilderStore
      }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Modal.Actions, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
        onClick: function onClick() {
          _this5.addDefaultValue();
        },
        content: "Agregar",
        size: "medium",
        className: "uif2btnStyle"
      }), /*#__PURE__*/_react.default.createElement(_core.Button, {
        onClick: function onClick() {
          _this5.closeDefaultValueModal();
        },
        content: "Cerrar",
        size: "medium",
        className: "uif2btnStyle uif2Primary"
      }))));
    }
  }]);

  return FormItemProperties;
}(_react.Component);

var Header = function Header(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Typography, _extends({
    component: "div",
    variant: "h6",
    gutterBottom: true,
    className: classes.titleHeader
  }, props), title);
};

var _default = FormItemProperties;
exports.default = _default;